export { default as Prism } from './Prism';
export type { PrismFpsSample } from './Prism';
